// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"f0ef41b9","265":"0629040a","364":"18b022ad","641":"dde4486f","860":"ef58c094","989":"3aa1bd15"}[chunkId] + ".chunk.js";
};